import React, { useState } from 'react';
import '../styles/CompDetails.css';

function CompDetails(props) {
    const details = props.details;
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    return (
        <div className="comp-details-outer-container">
            <span className="body-regular colour-secondary">
                {
                    details.length === 0 ?
                    "No additional details available for this property"
                    :
                    "Additional details"
                }
            </span>
            {
                details.map((item, index) =>
                    ((expanded === true) || (index < 2)) &&
                    <div 
                        className="comp-details-element"
                        key={index}
                    >
                        <span className="body-bold colour-primary">
                            {item.type.replaceAll("_", " ").replace(/^./, str => str.toUpperCase())}
                        </span>
                        <span className="body-regular colour-primary">
                            {item.detail.replace(/^./, str => str.toUpperCase())}
                        </span>
                    </div>
                )
            }
            {
                details.length > 2 &&
                <div 
                    className="comp-details-element cursor-pointer"
                    onClick={() => toggleExpanded()}
                >
                    <span className="body-bold colour-primary underline">
                        {expanded ? "Show less" : "Show more"}
                    </span>
                </div>
            }
        </div>
    )
};

export default CompDetails;